import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import '../../remark-element';
import './button';

export default {
  title: '@gsmlg/form/button',
  argTypes: {},
} as Meta;

export interface SwithProps {
  disabled?: boolean;
  loading?: boolean;
  text: string;
}

const modeList = [
  'primary',
  'dashed',
  'danger',
  'link',
  'text',
  'round',
  'circle',
  'block',
];

// prettier-ignore
const Template: Story<SwithProps> = ({ text, disabled, loading }) => {
  return html`<div>
    <h3>Button mode:</h3>
    <ul>
      <li
        style="margin-bottom: 0.618rem; display:flex; flex-direction: row; align-items: flex-start; gap: 1rem;"
      >
        <label style="width: 160px">Button mode: {empty mode}</label>
        <div style="width: calc(100% - 160px)">
          <wc-button
            ?disabled=${disabled}
            ?loading=${loading}
          >
            ${text}
          </wc-button>
        </div>
      </li>
      ${modeList.map(
        (mode) =>
          html`
            <li
              style="margin-bottom: 0.618rem; display:flex; flex-direction: row; align-items: flex-start; gap: 1rem;"
            >
              <label style="width: 160px">Button mode: ${mode}</label>
              <div style="width: calc(100% - 160px)">
                <wc-button
                  mode=${mode}
                  ?disabled=${disabled}
                  ?loading=${loading}
                >
                  ${mode == 'circle' ? text[0] : text}
                </wc-button>
              </div>
            </li>
          `,
      )}
    </ul>

    <remark-element>
      ## wc-button element Render button 
      \`\`\`html
      ${modeList.map(
        (mode) =>
      `
      Button mode: ${mode}
      <wc-button mode=${mode} ?disabled=${disabled} ?loading=${loading}>${text}</wc-button>
      `,
      )}
      ${`link: <wc-button href="https://github.com/gsmlg">Link to Home</wc-button>`}
      
      \`\`\` 
      ## CSS Variables 
      \`\`\`css

      var(--btn-primary, #1890ff)
      var(--btn-primary-hover, #40a9ff)

      var(--btn-danger, #ff4d4f) 
      var(--btn-danger-hover, #ff7875)

      var(--btn-disabled, #f5f5f5)
      var(--btn-border-disabled, #d9d9d9)

      var(--btn-hover, #40a9ff)

      var(--btn-link, #1890ff) 

      \`\`\`
    </remark-element>

    <h3>Link</h3>

    <wc-button href="https://github.com/gsmlg" target="_blank">Link to Profile</wc-button>

    <wc-button href="https://gsmlg-dev.github.io/lit">Link to Storybook</wc-button>
  </div>`;
};

export const Basic = Template.bind({});

Basic.args = {
  text: 'Enable Config',
  disabled: false,
  loading: false,
};
